import Graduation from '../media/Klawe.jpg';
//import newsitem_pic from '../media/newsitem_pic.jpg';
//import Regenstrief from '../media/Regenstrief.png';
//import HMC from '../media/HMC.png';
import Dodds from '../media/Graduation.jpg';
import Academy from '../media/AcademyAphasia.jpeg';
import Jiyeon from '../media/Jiyeon.jpg';
import Basketball from '../media/Basketball.jpg';
import SpringFest from '../media/SpringFest.jpg';
import Masters from '../media/Masters.png';
import PayPal from '../media/PayPal.jpeg';

export const news_items = [
  {
    pic: PayPal,
    year: 2026,
    text_p: <p>Started as an Agentic Engineering PhD Intern on PayPal's Agentic AI team.</p>
  },
  {
    pic: Masters,
    year: 2025,
    text_p: <p>Received my M.S. in Computer Science at Purdue along the way of my PhD journey.</p>
  }, 
  {
    pic: SpringFest,
    year: 2025,
    text_p: <p>Demoed our lab's robots to the Purdue community at <a href="https://ag.purdue.edu/springfest/index.html">SpringFest.</a></p>
  }, 
  {
    pic: Basketball,
    year: 2025,
    text_p: <p>Showcased our lab's robots at the <a href="https://www.linkedin.com/posts/purduescience_ai-machinelearning-purduescience-activity-7302451302070984704-8GiI?utm_source=share&utm_medium=member_desktop&rcm=ACoAACJREDABBchL4fKMBBxkmvSXxYaBucsmjco">Purdue vs. UCLA basketball game.</a></p>
  }, 
  {
    pic: Academy,
    year: 2024,
    text_p: <p>Attended the <a href="https://academyofaphasia2024.vfairs.com/en/#about">62nd Annual Meeting of the Academy of Aphasia</a> in Nara, Japan and received the Young Investigators Fellowship.</p>
  }, 
  {
    pic: Jiyeon,
    year: 2024,
    text_p: <p>Received the <a href="https://www.purdue.edu/research/rche/students/student-support.php">John W. Anderson Foundation</a> scholarship, which supports researchers interested in healthcare engineering.</p>
  },
  {
    pic: Graduation,
    year: 2023,
    text_p: <p>Graduated from HMC with high distinction and honors. Earned the <a href="https://www.hmc.edu/cs/student-awards/">Class of '94</a> award, the CS department's top award, and the RLCIE Fellow designation.</p>
  },
  {
    pic: Dodds,
    year: 2021,
    text_p: <p>Received the <a href="https://www.hmc.edu/about/2024/05/01/celebrating-hmc-community-leaders/#:~:text=Dean%20Sundberg%20Prize,-Ethan%20Sandoval%20'26&text=Established%20by%20Dana%20Seaton%20'06,impact%20on%20the%20College%20community.">Dean Chris Sundberg Prize</a>, recognizing a HMC junior who demonstrates exceptional leadership and has a positive impact on HMC community.</p>
  },
];